import React from 'react';
import * as moment from 'moment';
import { Col } from 'reactstrap';
import WmLabel from '../Layout/WmLabel';
const HtmlHelpers = {};
HtmlHelpers.buildMonthOptions = function (future) {
  let prior = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const totalMonths = 1 + prior + future;
  const options = [];
  const dt = moment().startOf('month').subtract(prior, 'months');
  for (let i = 0; i < totalMonths; i += 1) {
    const optionText = dt.format('MMMM YYYY');
    const optionValue = dt.format('L');
    options.push({
      label: optionText,
      value: optionValue
    });
    dt.add(1, 'months');
  }
  return options;
};
HtmlHelpers.buildOptions = (response, labelField, valueField) => {
  let options = [];
  if (response.data !== undefined) {
    options = response.data.map(d => ({
      label: d.attributes[labelField],
      value: d.attributes[valueField]
    }));
  }
  return options;
};
HtmlHelpers.capitalize = word => word.charAt(0).toUpperCase() + word.substring(1);
HtmlHelpers.poundsToTons = pounds => (pounds * 0.0005).toFixed(4);
HtmlHelpers.convertRailsErrors = errors => {
  const errMsgs = [];
  errors.forEach(error => {
    const keys = Object.keys(error);
    keys.forEach(key => {
      let msgbase = '';
      if (key !== 'base') {
        msgbase = HtmlHelpers.toCapitalizedWords(key);
      }
      const msgs = Array.isArray(error[key]) ? error[key] : [error[key]];
      msgs.forEach(msg => {
        const err = "".concat(msgbase, " ").concat(msg);
        errMsgs.push(err.replace('Uuid', ''));
      });
    });
  });
  return errMsgs;
};
HtmlHelpers.displayDuration = mins => {
  const hours = Math.floor(mins / 60);
  const minutes = Math.floor(mins % 60);
  const resultHour = "".concat(hours, " hrs ");
  const resultMin = "".concat(minutes, " minutes ");
  return (resultHour === '00 hrs ' ? '' : resultHour) + resultMin;
};
HtmlHelpers.dateSort = (a, b) => {
  const format = 'DD/MM/YYYY';
  return HtmlHelpers.sort(moment(a, format).format('x'), moment(b, format).format('x'));
};
HtmlHelpers.dateTimeSort = (a, b) => {
  const format = 'DD/MM/YYYY   h:mma';
  return HtmlHelpers.sort(moment(a, format).format('x'), moment(b, format).format('x'));
};
HtmlHelpers.numberSort = (a, b) => Number((a || '-1').replace(/[$,]/g, '')) - Number((b || '-1').replace(/[$,]/g, ''));
HtmlHelpers.sort = (a, b) => {
  if (a > b) {
    return 1;
  }
  if (a < b) {
    return -1;
  }
  return 0;
};
HtmlHelpers.dig = val => {
  const values = Array.isArray(val) ? val : [val];
  let obj = values[0];
  for (let i = 0; i < values.length; i += 1) {
    if (i !== 0) {
      obj = obj[values[i]];
    }
    if (obj === undefined || obj === null) {
      return null;
    }
  }
  return obj;
};
HtmlHelpers.fieldHasFeedback = (errorLabel, elem) => errorLabel && elem.nodeName.toLowerCase() !== 'button';
HtmlHelpers.findAncestor = (el, cls) => {
  let temp = el;
  while ((temp = temp.parentElement) && !temp.classList.contains(cls));
  return temp;
};
HtmlHelpers.format_date = date => {
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  };
  return date.toLocaleDateString('en-US', options).replace(/\//g, '-');
};
HtmlHelpers.format_utc_date_time = date => {
  let dt = '';
  if (!HtmlHelpers.is_blank(date)) {
    const offset = new Date().getTimezoneOffset() * -1;
    dt = moment(date).utcOffset(offset).format('MM/DD/YYYY h:mm a');
  }
  return dt;
};
HtmlHelpers.format_datetime = datetime => {
  let dt = '';
  if (!HtmlHelpers.is_blank(datetime)) {
    const offset = new Date().getTimezoneOffset() * -1;
    dt = moment(datetime).utcOffset(offset).format('YYYY-MM-DDTHH:mm');
  }
  return dt;
};
HtmlHelpers.freightTermOptions = [{
  label: 'Delivered',
  value: 'delivery_included'
}, {
  label: 'FOB',
  value: 'delivery_not_included'
}];
HtmlHelpers.freightTermsHash = function () {
  let showAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  let contract = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const options = {};
  if (showAll) {
    options['%'] = 'Show All';
  }
  options.delivery_included = 'Delivered';
  options.delivery_not_included = 'FOB';
  if (!contract) {
    options.delivered_by_vendor = 'Delivery by Vendor';
  }
  return options;
};
HtmlHelpers.getIncludedData = included => {
  const includes = {
    contracts: {},
    pickup_locations: {},
    contract_schedules: {},
    locations: {}
  };
  if (included !== undefined) {
    included.forEach(obj => {
      switch (obj.type) {
        case 'contracts':
          includes.contracts[obj.id] = obj.attributes;
          break;
        case 'pickup-locations':
          includes.pickup_locations[obj.id] = obj.attributes;
          break;
        case 'contract-schedules':
          includes.contract_schedules[obj.id] = obj.attributes;
          break;
        case 'locations':
          includes.locations[obj.id] = obj.attributes;
          break;
        default:
          break;
      }
    });
  }
  return includes;
};
HtmlHelpers.getWmLabel = props => props.labelColumns > 0 ? /*#__PURE__*/React.createElement(Col, {
  md: props.labelColumns,
  xs: props.labelColumns,
  className: "text-right"
}, /*#__PURE__*/React.createElement(WmLabel, {
  htmlFor: props.htmlfor,
  text: props.text,
  noUpcase: props.noUpcase
})) : '';
HtmlHelpers.getWmToken = async auth => {
  if (!(await auth.isAuthenticated())) {
    window.location.reload();
  }
  return auth.getIdToken();
};
HtmlHelpers.getUser = () => {
  const nameValue = HtmlHelpers.getUserFullName();
  return nameValue.split(' ')[0];
};
HtmlHelpers.getUserFullName = () => {
  let name = '';
  const token = JSON.parse(localStorage.getItem('okta-token-storage'));
  const nameValue = HtmlHelpers.dig([token, 'idToken', 'claims', 'name']);
  if (!HtmlHelpers.is_blank(nameValue)) {
    name = nameValue;
  }
  return name;
};
HtmlHelpers.is_not_null = val => val !== undefined && val !== null;
HtmlHelpers.is_blank = val => val === undefined || val === null || val === '';
HtmlHelpers.isEmpty = val => {
  let empty;
  if (val === undefined || val === null) {
    empty = true;
  } else if (Array.isArray(val)) {
    empty = val.length === 0;
  } else if (typeof val === 'object') {
    empty = Object.keys(val).length === 0;
  } else if (val === '') {
    empty = true;
  }
  return empty;
};
HtmlHelpers.isNotEmpty = val => !HtmlHelpers.isEmpty(val);
HtmlHelpers.setEachField = formEl => {
  const formLength = formEl.length;
  for (let i = 0; i < formLength; i += 1) {
    const elem = formEl[i];
    HtmlHelpers.setError(elem);
  }
};
HtmlHelpers.setError = elem => {
  const parent = HtmlHelpers.findAncestor(elem, 'form-group');
  const errorLabel = parent ? parent.querySelector('.invalid-feedback') : null;
  if (HtmlHelpers.fieldHasFeedback(errorLabel, elem)) {
    if (!elem.validity.valid) {
      let msg = elem.validationMessage;
      if (msg === 'Please match the requested format.') {
        msg = elem.title;
      }
      errorLabel.textContent = msg;
      errorLabel.style.display = 'block';
    } else {
      errorLabel.textContent = '';
      errorLabel.style.display = 'none';
    }
  }
};
HtmlHelpers.toCapitalizedWords = name => {
  const words = name.match(/[A-Za-z][^_\-A-Z]*/g) || [];
  return words.map(HtmlHelpers.capitalize).join(' ');
};
HtmlHelpers.validateForm = formEl => {
  HtmlHelpers.setEachField(formEl);
  return formEl.checkValidity() !== false;
};
HtmlHelpers.addIt = function (first, second) {
  let decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;
  let value = first;
  if (first === '~~' || second === '~~') {
    value = 'Check Agris';
  } else {
    value = (parseFloat(first) + parseFloat(second)).toFixed(decimals);
  }
  return value;
};
HtmlHelpers.subtractIt = function (first, second) {
  let decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;
  let value = '';
  if (first === '~~' || second === '~~') {
    value = 'Check Agris';
  } else {
    value = (parseFloat(first) - parseFloat(second)).toFixed(decimals);
  }
  return value;
};
HtmlHelpers.toFixed = (num, precision) => (+"".concat(Math.round(+"".concat(num, "e").concat(precision)), "e").concat(-precision)).toFixed(precision);
HtmlHelpers.utilizeFocus = () => {
  const ref = React.createRef();
  const setFocus = () => {
    ref.current && ref.current.focus();
  };
  return {
    setFocus,
    ref
  };
};
HtmlHelpers.sleep = delay => new Promise(resolve => setTimeout(resolve, delay));
HtmlHelpers.boldRed = text => /*#__PURE__*/React.createElement("div", {
  style: {
    color: 'red',
    fontWeight: 'bold'
  }
}, text);
HtmlHelpers.inactiveRed = text => ['Inactive', 'No'].includes(text) ? HtmlHelpers.boldRed(text) : text;
export default HtmlHelpers;